import React, { useState, useEffect } from "react";

import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";
import { NavLink } from "react-router-dom";
import MUIDataTable from "mui-datatables";
//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";

//Material UI Icons
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
// Material UI Component
import {
  FormGroup,
  FormLabel,
  FormControl,
  FormHelperText,
  NativeSelect,
  // ListItemText,
  TextField,
  // Checkbox,
  // FormControlLabel,
  // Grid,
  // Select,
  Input,
  InputLabel,
  // MenuItem,
  Modal,
  Backdrop,
  //Fade,
  fade,
  Button,
  Grid,
  Breadcrumbs,
  Typography,
  Fade,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
// Material Icons
import { AssessmentTwoTone, FaceRounded } from "@material-ui/icons";
import { get_cookies, isLoggedIn } from "../../../components/Cookies/Cookies";
import Autocomplete from "@material-ui/lab/Autocomplete";
import MessageBox from "../../../components/MessageBox/MessageBox";
const useStyles = makeStyles((theme) => ({
  // modal: {
  //   display: "flex",
  //   alignItems: "center",
  //   justifyContent: "center",
  // },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",

    margin: "0 auto",
  },
  textField: {
    marginTop: "-15px",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: "400px",
    maxHeight: "100%",
    overflow: "auto",
  },
}));

const UpdateGlAccount = (props) => {
  const { showModal, data } = props;
  const [posts, setPosts] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(true);
  const [open, setOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: new Date(),
    endDate: addDays(new Date(), 7),
  });
  const [filterType, setFilterType] = useState("1");
  const [description, setDescription] = useState("");
  const [address, setAddress] = useState("");
  const [contactNo, setContactNo] = useState("");
  const [contactPerson, setContactPerson] = useState("");
  const [otherInfo, setOtherInfo] = useState("");
  const [idno, setIdno] = useState("");
  const [downloadFlag, setDownloadFlag] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [branchIdData, setBranchIdData] = useState([]);
  const [creditData, setCreditData] = useState([]);
  const [branchidno, setBranchidno] = useState("");
  const [supplierData, setSupplierData] = useState("");
  const [type, setType] = useState();
  const classes = useStyles();

  const [showMsgBox, setShowMsgBox] = useState(false);
  const [msgBoxContent, setMsg] = useState("empty");
  const [btnAddDisabled, setBtnAddDisabled] = useState(false);
  const [msgType, setMsgType] = useState("success");
  const [displayView, setDisplayView] = useState(false);


  const selectBranchIdProps = {
    options: branchIdData,
    getOptionLabel: (option) => option.idno,
  };
  const accountType = [
    "Assets","Bank Account","Cost of Goods Sold","Expenses","Equity","Income","Liabilities"
   ]
   
  const selectCreditProps = {
    options: accountType,
    getOptionLabel: (option) => option,
  };


  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };


  const updateSupplier = async () => {
    await axios
      .post(process.env.REACT_APP_API_URL + "update_gl_accounts_list", {
        name: description == ""? data.description:description,
        id: data.id,
        acttype: type == null ?data.acttype : type,
      })
      .then(function (res) {
        // console.log("updated", res);
        handleModalClose();
        showModal('Update Successful ','success');
        // setUserRoleData(res.data.data.position);
        // setCanApprove(res.data.data.position.can_approve.toString());
        // setCanEdit(res.data.data.position.can_edit.toString());
        // setCanDelete(res.data.data.position.can_delete.toString());
        // setCanProcess(res.data.data.sposition.can_process.toString());
        // setLoading(true);
      })
      .catch(function (error) {
        showModal('Something went wrong '+ error.message, 'warning');
        handleModalClose();
        // console.log(error);
      });
  };

  useEffect(() => {
    console.log('1111',data);
    //
    // getSupplier();
  }, []);
  return (
    <div>
  <Button
        variant="contained"
        color="primary"
        onClick={handleModalOpen}
        style={{ backgroundColor: "#4caf50", color: "#fff",marginRight:10 }}
      >
        Edit
      </Button>
      <MessageBox in={showMsgBox} content={msgBoxContent} type={msgType} />
      <div>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={modalOpen}
          onClose={handleModalClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <div className={classes.paper}>
            <h2 id="transition-modal-title">Update Gl Account</h2>
            <form action="" className={classes.root}>
              <div>
                <TextField
                  id="outlined-full-width"
                  label="Gl Account"
                  defaultValue={data.description}
                  style={{ margin: 8 }}
                  fullWidth
                  margin="normal"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant="outlined"
                  onChange={(e) => {
                    setDescription(e.target.value);
                  }}
                />
              </div>
  

              <div style={{ marginLeft: 8, width: "100%" }}>
                {/* <TextField id="outlined-basic" label="Branch Id No" variant="outlined" placeholder="Branch Id No" inputProps={{ 'aria-label': 'User Name' }} value={branchidno} onChange={e => setBranchidno(e.target.value)}/> */}
                <Autocomplete
                  {...selectCreditProps}
                  id="auto-complete"
                  autoComplete
                  includeInputInList
                  defaultValue={data.acttype}
                  className={classes.autoComplete}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Type"
                      margin="normal"
                      variant="outlined"
                    />
                  )}
                  onChange={(event, newValue) => {
                    if (!newValue == "" || !newValue == null) {
                      setType(newValue);
                    } else {
                      setType(null);
                    }
                  }}
                />
              </div>

              <div className={classes.button}>
                <Grid container spacing={2} justifyContent="space-between" style={{paddingRight:50}}>
                  <Grid item xs={12} sm={2}>
                    <Button
                      variant="contained"
                      onClick={handleModalClose}
                   
                    >
                      Close
                    </Button>
                  </Grid>
     
                  <Grid item xs={12} sm={2}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={(e) => {
                        updateSupplier();
                      }}
                    >
                      Update
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </form>
          </div>
        </Modal>
      </div>
    </div>
  )
}

export default UpdateGlAccount
